import {CompanyKeyEnum} from '../../../../../../../service/company-v2/company-const';
import {CompanyFormType} from '../../../../../../../service/company-v2/company-type';
import {Form} from '../../../../../../../typings/antd';

import {TemporaryClosedButton} from './temprorary-closed-button/temporary-closed-button';

type PropsType = {
    name: CompanyKeyEnum.TemporaryClosed;
};

export function TemporaryClosedFormItem(props: PropsType): JSX.Element {
    const {name} = props;

    const form = Form.useFormInstance<CompanyFormType>();

    return (
        <Form.Item<CompanyFormType>
            getValueFromEvent={(checked: boolean) => {
                if (!checked) {
                    form.setFieldsValue({[CompanyKeyEnum.OpeningDate]: null});
                }

                return checked;
            }}
            name={name}
            valuePropName="checked"
        >
            <TemporaryClosedButton />
        </Form.Item>
    );
}
